export const SET_CURRENT_VARIANT = 'SET_CURRENT_VARIANT';
export const SET_VARIANTS = 'SET_VARIANTS';
export const GET_PRODUCT_PRICES = 'GET_PRODUCT_PRICES';

export default {
    SET_CURRENT_VARIANT,
    SET_VARIANTS,
    GET_PRODUCT_PRICES,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/product-variants/mutations.js